<div class="flex flex-col w-100 px-2" [formGroup]="formGroup">
  <mat-checkbox color="primary" [formControlName]="form.code" #checkbox (change)="userChange()">
    {{ form.caption }}
  </mat-checkbox>
  @if (form.fields.length > 0 && checkbox.checked) {
    <div class="flex flex-row flex-wrap w-100">
      @for (field of form.fields; track field) {
        <div class="flex-auto">
          @if (field.type == 'text') {
            <mat-form-field floatLabel="always" class="w-100">
              <mat-label>{{ field.caption }}</mat-label>
              <input matInput [formControlName]="field.code" (change)="userChange()">
            </mat-form-field>
          }
          @if (field.type == 'number.weight') {
            <mat-form-field class="w-100" floatLabel="always">
              <mat-label>{{ field.caption }}</mat-label>
              <input matInput [formControlName]="field.code" (change)="userChange()">
              @if (metric$ | async) {
                <span matSuffix i18n>kgs</span>
              }
              @if (!(metric$ | async)) {
                <span matSuffix i18n>lbs</span>
              }
            </mat-form-field>
          }
          @if (field.type == 'number.currency') {
            <mat-form-field class="w-100" floatLabel="always">
              <mat-label>{{ field.caption }}</mat-label>
              <input matInput [formControlName]="field.code" (change)="userChange()">
              <span matPrefix>$</span>
            </mat-form-field>
          }
          @if (field.type == 'choice') {
            <mat-form-field class="w-100" floatLabel="always">
              <mat-label>{{ field.caption }}</mat-label>
              <mat-select [formControlName]="field.code" (selectionChange)="userChange()">
                @for (choice of field.choices; track choice) {
                  <mat-option [value]="choice.code">{{ choice.caption }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      }
    </div>
  }
</div>
